import axios from "axios";

export default {
  namespaced: true,

  state: {
    userData: null,
    coinData: null
  },

  getters: {
    Aiuser: state => state.userData,
    CoinData: state => state.coinData
  },

  mutations: {
    setUserData(state, user) {
      state.userData = user;
    },
    setCoinData(state, coin) {
      state.coinData = coin;
    }
  },

  actions: {
    getCoins({ commit }, data) {
      axios
        .post("/api/AI/get_credits", data)
        .then(response => {
          commit("setCoinData", response.data.data);
        });
    },
    getAIUserData({ commit }) {
      axios
        .get("/api/AI/get_user")
        .then(response => {
          if(response.data.success){
            commit("setUserData", response.data.data);
          }else{
            localStorage.removeItem("AIauthToken");
            //this.$router.push('/design-ai/login');
          }
        })
        .catch(() => {
          localStorage.removeItem("AIauthToken");
          //this.$router.push('/design-ai/login');
        });
    },
    sendLoginRequest({ commit }, data) {
      commit("setErrors", {}, { root: true });
      return axios
        .post( "/api/AI/design", data)
        .then(response => { 
          commit("setUserData", response.data.data.user);
          localStorage.setItem("AIauthToken", response.data.data.token);
        });
    },
    sendRegisterRequest({ commit }, data) {
      commit("setErrors", {}, { root: true }); 
      return axios
        .post("/api/AI/design", data)
        .then(response => {
          if(response.data.data.user){
            commit("setUserData", response.data.data.user);
            localStorage.setItem("AIauthToken", response.data.data.token);
          }else{
            commit("setUserData", null);
            localStorage.removeItem("AIauthToken");
          }
        });
    },
 
    sendAILogoutRequest({ commit }) {
      commit("setUserData", null);
      localStorage.removeItem("AIauthToken");
    },
    sendVerifyResendRequest() {
      return axios.get("/api/AI/design/email/resend");
    },
    sendVerifyRequest({ dispatch }, hash) {
      return axios
        .get("/api/AI/design/email/verify/" + hash)
        .then(() => {
          dispatch("getAIUserData");
        });
    }
  }
};
